"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _IceTree = _interopRequireDefault(require("@/components/IcePopSelector/IceTree.vue"));
var _index = _interopRequireDefault(require("@/components/IceQueryGrid/index"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "IceTreeGrid",
  props: {
    parentProp: {
      //父节点字段名，用于刷新网格数据
      type: String
    },
    parentValueProp: {
      //用于右边网格刷新，表示网格选中值，如果则用树形的value值
      type: String
    }
  },
  data: function data() {
    return {
      selectValue: null
    };
  },
  methods: {
    handleNodeClick: function handleNodeClick(data, node, nodeComponent) {
      var _this = this;
      //let item = this.$attrs.query.find(item => item.type == 'static' && item.code == this.parentProp);
      if (this.parentValueProp) {
        this.selectValue = node.data[this.parentValueProp];
      } else {
        this.selectValue = data;
      }
      this.$emit("node-click", data, node, nodeComponent);
      this.$nextTick(function () {
        _this.$refs.queryGrid.handleQuery();
      });
    },
    cleanColumnSelect: function cleanColumnSelect() {
      this.$refs.queryGrid.cleanColumnSelect();
    },
    closeSelection: function closeSelection(value) {
      this.$refs.queryGrid.closeSelection(value);
    },
    dataFilter: function dataFilter(data) {
      if (data) {
        data.forEach(function (item) {
          delete item.children;
        });
        return data;
      } else {
        return [];
      }
    },
    addNode: function addNode(data) {
      this.$refs.tree.addNode(data);
    },
    updateNode: function updateNode(data) {
      this.$refs.tree.updateNode(data);
    },
    deleteNode: function deleteNode() {
      this.$refs.tree.deleteNode();
    },
    nodeCheck: function nodeCheck(changeNode, nodeStatus) {
      this.$emit("node-check", changeNode, nodeStatus);
    },
    setChecked: function setChecked(key_data, checked, deep) {
      this.$refs.tree.setChecked(key_data, checked, deep);
    },
    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
      return this.$refs.tree.getCheckedNodes(leafOnly, includeHalfChecked);
    },
    setCheckedNodes: function setCheckedNodes(nodes) {
      this.$refs.tree.setCheckedNodes(nodes);
    },
    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
      this.$refs.tree.setCheckedKeys(keys, leafOnly);
    },
    reDoSelection: function reDoSelection() {
      this.$refs.queryGrid.reDoSelection();
    }
  },
  watch: {},
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this2 = this;
    if (this.parentProp) {
      this.$attrs.query.push({
        type: "static",
        code: this.parentProp,
        sqlExp: "=",
        value: function value() {
          return _this2.selectValue;
        }
      });
    }
  },
  components: {
    IceQueryGrid: _index.default,
    IceTree: _IceTree.default
  }
};